import { Controller } from "@hotwired/stimulus"

// Botón "Comprar" de las tarjetas de entrada premium (Markets Experience, ENH-RNK-3061):
// preselecciona la modalidad elegida en el formulario de pago y abre el modal reutilizando
// el flujo de pago existente (Inscribir.start + controller `pagos` + Stripe/PayPal).
export default class extends Controller {
  comprar(event) {
    const modalidadId = event.currentTarget.dataset.modalidad
    const radio = document.querySelector(
      `#formulario-inscripcion input[name="modalidad_id"][value="${modalidadId}"]`
    )
    if (radio) {
      radio.checked = true
      radio.dispatchEvent(new Event("change", { bubbles: true }))
    }
    if (window.Inscribir) window.Inscribir.start("evento")
    this.retitula()
  }

  // El Dialog compone su título genérico ("Inscripción al evento"); el diseño Markets
  // lo titula "Entradas especiales". Solo toca el dialog del modal de entradas
  // (contiene `.rnk-MacroEvento_Pay`), no el checkout de cursos/webinars.
  retitula() {
    const titulo = document.querySelector("dialog-modal.rnk-CheckoutDialog:has(.rnk-MacroEvento_Pay) dialog-title")
    if (titulo) titulo.textContent = "Entradas especiales"
  }
}
